import React from "react";
import PropTypes from "prop-types";
import { Generic, JSONLD } from "react-structured-data";

const FaqStructuredData = (props) => {

    const FaqSchema = () => {
        let data = [];
        props.faqs.forEach((items, key) => {
            let answerArr = [...items];
            answerArr.shift();
            data.push({
                "@type": "Question",
                "name": items[0],
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": answerArr.join('. ').replace(/<[^>]+>/g, '')
                }
            });
        });
        return data;
    };

    return (
        <JSONLD>
            <Generic type="FAQPage" jsonldtype="FAQPage" schema={{mainEntity: [FaqSchema()]}} />
        </JSONLD>
    );

};

FaqStructuredData.propTypes = {
    faqs: PropTypes.array.isRequired
};

export default FaqStructuredData;


// WEBPACK FOOTER //
// ./resources/assets/js/components/FaqStructuredData.js